import { MutationTree, ActionTree, Module } from 'vuex';
import { RootState, GeneralState } from './../types';

const state: GeneralState = {
  showingModal: '',
  toastError: '',
  toastSuccess: '',
  toastInfo: ''
};

const mutations: MutationTree <GeneralState> = {
  setModal(generalState, showingModal: string = '') {
    generalState.showingModal = showingModal;
  },
  setToastError(generalState, errorText: string = '') {
    generalState.toastError = errorText;
  },
  setToastSuccess(generalState, successText: string = '') {
    generalState.toastSuccess = successText;
  },
  setToastInfo(generalState, infoText: string = '') {
    generalState.toastInfo = infoText;
  }
};

const actions: ActionTree <GeneralState, RootState> = {
};

export const general: Module<GeneralState, RootState> = {
  state,
  mutations,
  actions
};
